/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-19 17:22:39
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-19 11:51:00
 */
import React from 'react'
import { Button, Popover } from 'antd'
import { EditableColumnType } from '../../compnents/list/EditableList'
import moment from 'moment'
import { ItemCompletionType } from '../completion/completionSlice'
import { DateTimeFormatSimple } from '../../models/datetime'
import { Dimen } from '../../models/dimen'

export const Columns = (startIndex: number): EditableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, i) => `${1 + i + startIndex}`,
    },
    {
      title: '到货单号',
      align: 'center',
      dataIndex: 'arrivalOrderNumber',
      width: '8rem',
      ellipsis: true,
      key: 'arrivalOrderNumber',
      render: (_, t) => {
        return t.arrivalOrderNumber ? t.arrivalOrderNumber : '-'
      },
    },
    {
      title: '到货日期',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      dataIndex: 'arrivalDate',
      key: 'arrivalDate',
      render: (_, t) => {
        return t.arrivalDate
          ? moment(t.arrivalDate).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '商品编码',
      align: 'center',
      dataIndex: 'no',
      key: 'no',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.no ? t.no : '-'
      },
    },
    {
      // 商品名称/生产厂家/规格/剂型
      title: '产品信息',
      align: 'left',
      width: '16rem',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <Popover
            content={
              <>
                <div style={{ height: '55px' }}>
                  <p
                    style={{
                      height: '28px',
                      lineHeight: '36px',
                      padding: '0',
                      margin: '0',
                      fontSize: '16px',
                      fontWeight: 'bolder',
                    }}
                  >
                    {t?.name}
                  </p>
                  <p
                    style={{
                      height: '28px',
                      lineHeight: '24px',
                      padding: '0',
                      margin: '0',
                      color: '#999999',
                      fontSize: '14px',
                    }}
                  >
                    {t.productInfo}
                  </p>
                </div>
              </>
            }
            placement='bottom'
          >
            <div style={{ height: '55px' }}>
              <p
                style={{
                  height: '28px',
                  lineHeight: '36px',
                  padding: '0',
                  margin: '0',
                  fontSize: '16px',
                  fontWeight: 'bolder',
                }}
              >
                {t?.name}
              </p>
              <p
                style={{
                  height: '28px',
                  lineHeight: '24px',
                  padding: '0',
                  margin: '0',
                  color: '#999999',
                  fontSize: '14px',
                }}
              >
                {t.productInfo}
              </p>
            </div>
          </Popover>
        )
      },
    },
    {
      title: '产地',
      align: 'center',
      dataIndex: 'origin',
      key: 'origin',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.origin ? t.origin : '-'
      },
    },
    {
      title: '供应商',
      align: 'center',
      dataIndex: 'supplierName',
      key: 'supplierName',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.supplierName ? t.supplierName : '-'
      },
    },

    {
      title: '供应商地址',
      align: 'center',
      dataIndex: 'supplierAddress',
      key: 'supplierAddress',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        return t.supplierAddress ? t.supplierAddress : '-'
      },
    },

    {
      title: '供应商联系方式',
      align: 'center',
      dataIndex: 'supplierPhone',
      key: 'supplierPhone',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.supplierPhone ? t.supplierPhone : '-'
      },
    },

    {
      title: '注册人',
      align: 'center',
      dataIndex: 'registrant',
      key: 'registrant',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.registrant ? t.registrant : '-'
      },
    },

    {
      title: '备案人',
      align: 'center',
      dataIndex: 'filer',
      key: 'filer',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.filer ? t.filer : '-'
      },
    },

    {
      title: '许可证号码',
      align: 'center',
      dataIndex: 'licenceNumber',
      key: 'licenceNumber',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.licenceNumber ? t.licenceNumber : '-'
      },
    },
    {
      title: '上市许可持有人',
      align: 'center',
      dataIndex: 'lstdLicHolder',
      key: 'lstdLicHolder',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.lstdLicHolder ? t.lstdLicHolder : '-'
      },
    },
    {
      title: '批准文号',
      align: 'center',
      dataIndex: 'approvalNumber',
      key: 'approvalNumber',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.approvalNumber ? t.approvalNumber : '-'
      },
    },
    {
      title: '批号',
      align: 'center',
      dataIndex: 'batchNo',
      key: 'batchNo',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.batchNo ? t.batchNo : '-'
      },
    },
    {
      title: '购进价格',
      align: 'center',
      dataIndex: 'arrivalUnitPrice',
      key: 'arrivalUnitPrice',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.arrivalUnitPrice ? t.arrivalUnitPrice?.toFixed(5) : '-'
      },
    },
    {
      title: '零售单价',
      align: 'center',
      dataIndex: 'retailPrice',
      key: 'retailPrice',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.retailPrice ? t.retailPrice?.toFixed(2) : '-'
      },
    },
    {
      title: '生产日期',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      dataIndex: 'productDate',
      key: 'productDate',
      render: (_, t) => {
        return t.productDate
          ? moment(t.productDate).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '有效期至',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      dataIndex: 'deadline',
      key: 'deadline',
      render: (_, t) => {
        return t.deadline
          ? moment(t.deadline).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '到货数量',
      align: 'center',
      dataIndex: 'totalQuantity',
      key: 'totalQuantity',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.totalQuantity != -1 ? t.totalQuantity : '-'
      },
    },
    {
      title: '验收合格数量',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'qualifiedQuantity',
      key: 'qualifiedQuantity',
      render: (_, t) => {
        return t.qualifiedQuantity != -1 ? t.qualifiedQuantity : '-'
      },
    },
    {
      title: '验收不合格数量',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'defectiveQuantity	',
      key: 'defectiveQuantity	',
      render: (_, t) => {
        return t.defectiveQuantity != -1 ? t.defectiveQuantity : '-'
      },
    },
    {
      title: '质量状况',
      align: 'center',
      dataIndex: 'qualityStatus',
      key: 'qualityStatus',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.qualityStatus != 0 ? t.qualityStatus : '-'
      },
    },
    {
      title: '验收结论',
      align: 'center',
      dataIndex: 'acceptanceConclusion',
      key: 'acceptanceConclusion',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.acceptanceConclusion ? t.acceptanceConclusion : '-'
      },
    },
    {
      title: '备注',
      align: 'center',
      dataIndex: 'remark',
      key: 'remark',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.remark ? t.remark : '-'
      },
    },
    {
      title: '验收人',
      align: 'center',
      dataIndex: 'createUser',
      width: '6rem',
      ellipsis: true,
      key: 'createUser',
      render: (_, t) => {
        return t.createUser ? t.createUser : '-'
      },
    },
    {
      title: '验收日期',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      dataIndex: 'creatTime',
      key: 'creatTime',
      render: (_, t) => {
        return t.creatTime
          ? moment(t.creatTime).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '采购日期',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      dataIndex: 'procurementDate',
      key: 'procurementDate',
      render: (_, t) => {
        return t.procurementDate
          ? moment(t.procurementDate).format(DateTimeFormatSimple)
          : '-'
      },
    },
  ]
}
